import { addMonths, startOfMonth, subMonths } from 'date-fns';
import { useState } from 'react';

type CalendarControlOptions = {
	initialDate?: Date | null;
};

// Controls the view state of the calendar, i.e. the currently viewed month and controls to navigate between months.
export const useCalendarControl = ({ initialDate }: CalendarControlOptions) => {
	const [month, setMonth] = useState<Date>(startOfMonth(initialDate || new Date()));

	const onNextMonth = () => {
		setMonth(addMonths(month, 1));
	};

	const onPrevMonth = () => {
		setMonth(subMonths(month, 1));
	};

	const onGoToMonth = (date: Date) => {
		setMonth(startOfMonth(date));
	};

	const onResetCalendar = () => {
		setMonth(startOfMonth(initialDate || new Date()));
	};

	return {
		month,
		onGoToMonth,
		onPrevMonth,
		onNextMonth,
		onResetCalendar,
	};
};
